import { getCustomerSelector } from '@modules/customer';
import { FormattedMessage } from 'react-intl';
import { toAbsoluteUrl } from '@helpers/index';
import { useSelector } from 'react-redux';
import { getPetSelector } from '@modules/subscriptions/core/selectors';
import { RafLink } from '../raf-link/RafLink';
import { useMemo } from 'react';
import { getVariantProductInfoSelector } from '@modules/products/core/selectors';
import clsx from 'clsx';

export const WelcomeMessage = () => {
  const pet = useSelector(getPetSelector);
  const customer = useSelector(getCustomerSelector);
  const variantProductInfo = useSelector(getVariantProductInfoSelector);
  const cycle = variantProductInfo?.options?.cycle;
  const maxRewardOrder = Number(cycle) === 28 ? 22 : 23;

  const currentFoc = useMemo(() => {
    const tags = Array.isArray(customer.tags)
      ? customer.tags
      : typeof customer.tags === 'string'
        ? (customer.tags as string).split(',')
        : [];

    const focTag = tags.find((t: string) => t.trim().startsWith('FOC-'));
    if (!focTag) return 1;

    const match = focTag.trim().match(/FOC-(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }, [customer]);

  return (
    <div className="welcome-message shadow-pfotenpunkte">
      <div className="welcome-message-wrapper ">
        <div
          className={clsx('welcome-message-cloud md:flex', {
            'flex-row': currentFoc < maxRewardOrder,
          })}>
          <div className="md:w-7/12 lg:w-3/5 xl:w-2/3 ">
            <h3 className="md:hidden">
              <FormattedMessage
                id="DASHBOARD.WELCOME.HEADING_MOBILE"
                values={{
                  hasName: customer?.firstName ? 'yes' : 'no',
                  name: customer?.firstName ?? '',
                  break: <br />,
                }}
              />
            </h3>
            <div className="flex gap-[5px] w-full justify-between">
              <div className="welcome-wrapper">
                <p className="welcome-message-cloud-extra">
                  <FormattedMessage
                    id="DASHBOARD.WELCOME.TEXT"
                    values={{
                      name: pet?.name,
                      highlight: (chunks) => <span>{chunks}</span>,
                    }}
                  />
                </p>
                <div className="md:hidden">
                  <RafLink />
                </div>
              </div>
              <div className="welcome-message-cloud-image-wrapper md:hidden">
                <img src={toAbsoluteUrl('/media/img/misc/welcome-desktop.png')} alt="welcome" />
              </div>
            </div>
          </div>
          <div className="hidden md:block md:w-5/12 welcome-message-cloud-image lg:w-2/5 xl:w-1/3">
            <div className="welcome-message-cloud-image-wrapper">
              <img src={toAbsoluteUrl('/media/img/misc/welcome-desktop.png')} alt="welcome" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
